<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content>
			<template #extra-heading>
				<div class="align-center">
					<h1>{{ page.title || page.header }}</h1>
					<div class="icons-group">
						<span> <font-awesome-icon icon="fa fa-users" size="1x" />{{ page.pax }} </span>
						<span> <font-awesome-icon icon="fa fa-arrows" size="1x" />{{ page.surface }} </span>
						<span> <font-awesome-icon icon="fa fa-euro-sign" size="1x" />{{ page.price }} </span>
					</div>
				</div>
			</template>
			<template #extra-content>
				<div v-parse-links v-html="page.content" />
				<p v-if="page.bookingID">
					<book-button class="button cta" :data-roomID="page.booking - id">
						{{ $t('bookThisRoom') }}
					</book-button>
				</p>
			</template>
		</main-content>

		<section class="main-content room-info">
			<div class="row background-secondary">
				<div class="columns column12 align-center">
					<h2>{{ $t('aboutThisRoom') }}</h2>
				</div>
				<!-- <div class="columns column12">
					<div v-parse-links v-html="page.extraContent" />
				</div> -->
				<div class="columns column12">
					<div class="room-icons">
						<div v-for="facility in page.facilities" :key="facility.id" class="icon-holder">
							<font-awesome-icon :icon="`fal fa-${facility.icon}`" size="1x" />
							<span>{{ facility.content }}</span>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="main-content gallery-section">
			<div class="row">
				<div v-for="(item, index) in page.images" :key="index" class="columns column4">
					<picture>
						<source v-if="item.imagesWebp" :srcset="item.imagesWebp" type="image/webp" />
						<source :srcset="item.images" />
						<img :src="item.image" :alt="item.imageAlt" loading="lazy" />
					</picture>
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();

await fetchPage();
</script>

<style lang="scss" scoped>
.main-content {
	:deep(ul) {
		padding: 0 0 0 20px;
	}

	:deep(li) {
		width: 50%;
		float: left;
		padding: 0 50px 0 0;
	}
}

.icon-holder {
	color: var(--subtitle-color);
	width: 32%;
	margin: 10px 0;

	i,
	svg {
		margin: 0 5px 0 0;
	}
}

.room-item .room-icons {
	max-width: 600px;
}

.room-info {
	padding: 0;

	.row {
		padding: 50px 30px;

		ul {
			padding-left: 20px;
		}
	}
}

.icons-group {
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
	align-items: center;

	span {
		display: flex;
		flex-flow: row nowrap;
		justify-content: flex-start;
		align-items: center;
		margin: 0 15px 0 0;
	}

	svg {
		margin: 0 5px 0 0;
		font-size: calc(var(--body-font-size) + 3px);
	}
}

.room-icons {
	max-width: 700px;
	margin: 20px auto;
	display: flex;
	flex-flow: row wrap;
	justify-content: flex-start;
	align-items: center;

	.icon-holder {
		display: flex;
		flex-flow: row wrap;
		justify-content: space-between;
		align-items: center;
		width: 31%;
		margin: 7px 2% 7px 0;

		span {
			display: flex;
			flex-flow: row nowrap;
			justify-content: flex-start;
			align-items: center;
			margin: 0 15px 0 0;
			width: calc(100% - 50px);
		}

		svg {
			margin: 0 12px 0 0;
			font-size: calc(var(--body-font-size) + 3px);
		}
	}
}

.gallery-section .columns {
	margin: 15px 0;
}

.gallery-section img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

@media (max-width: 920px) {
	.room-icons {
		.icon-holder {
			width: 48%;
		}
	}

	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto;
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse;
	}

	.contentblock-content {
		margin: 0 auto 50px;
		padding: 50px 30px;
	}

	.room-info .column12 {
		text-align: left;
	}
}

@media (max-width: 680px) {
	.icon-holder {
		width: 49%;
	}

	.room-icons {
		.icon-holder {
			width: 100%;
			margin: 5px 0;
		}
	}
}
</style>
